<template>
  <el-text-field
    email
    :label="label"
    :tooltip="tooltip"
    :readonly="readonly"
    :need="need"
    :required="required"
    :validate-key="validateKey"
    v-model="pastas"
    :autofocus="autofocus"
  />
</template>

<script>
export default {
  name: 'ElPastas',
  props: {
    value: String,
    readonly: Boolean,
    need: Boolean,
    required: Boolean,
    label: String,
    tooltip: String,
    validateKey: String,
    autofocus: { type: Boolean, default: false },
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    pastas: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
